import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Sparkles, Wand2, Printer, PartyPopper } from 'lucide-react';

const steps = [
  {
    icon: Camera,
    title: 'Fotoğraf Çek',
    description: 'Kioskumuzun önünde poz verin ve harika bir fotoğraf çekin. Hazır mısınız?',
    color: 'from-purple-500 to-pink-500',
    iconColor: 'text-purple-500'
  },
  {
    icon: Sparkles,
    title: 'Tema Seç',
    description: 'Zengin tema koleksiyonumuzdan favorinizi seçin. Süper kahraman, sanat eseri ya da fantastik dünyalar!',
    color: 'from-pink-500 to-rose-500',
    iconColor: 'text-pink-500'
  },
  {
    icon: Wand2,
    title: 'AI Sihri',
    description: 'Yapay zeka sihrini izleyin! Fotoğrafınız seçtiğiniz temaya göre saniyeler içinde dönüşüyor.',
    color: 'from-rose-500 to-orange-500',
    iconColor: 'text-rose-500'
  },
  {
    icon: Printer,
    title: 'Yazdır & Paylaş',
    description: 'Muhteşem AI fotoğrafınızı anında yazdırın veya dijital olarak kaydedin. Anılarınız hazır!',
    color: 'from-orange-500 to-cyan-500',
    iconColor: 'text-orange-500'
  },
  {
    icon: PartyPopper,
    title: 'Eğlence Başlasın!',
    description: 'Arkadaşlarınızla paylaşın, sosyal medyada gösterin ve etkinliğin yıldızı olun!',
    color: 'from-cyan-500 to-purple-500',
    iconColor: 'text-cyan-500'
  }
];

export function HowItWorks() {
  return (
    <section className="py-20 px-4 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-purple-900/10 to-transparent"></div>
      
      <div className="container mx-auto max-w-7xl relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-purple-400 via-pink-400 to-cyan-400 bg-clip-text text-transparent">
            Nasıl Çalışır?
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Sadece 5 basit adımda unutulmaz anılar yaratın. AI teknolojisi ile fotoğraflarınız saniyeler içinde sanat eserine dönüşüyor!
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.05, y: -10 }}
                className="relative group"
              >
                <div className="relative bg-gray-900/50 backdrop-blur-sm rounded-2xl p-6 border border-gray-800 hover:border-purple-500/50 transition-all duration-300 h-full">
                  {/* Step Number */}
                  <div className={`absolute -top-4 -right-4 w-12 h-12 rounded-full bg-gradient-to-r ${step.color} flex items-center justify-center text-white font-bold text-lg shadow-lg`}>
                    {index + 1}
                  </div>

                  {/* Icon */}
                  <div className={`w-16 h-16 rounded-xl bg-gradient-to-r ${step.color} p-0.5 mb-4`}>
                    <div className="w-full h-full bg-gray-900 rounded-xl flex items-center justify-center">
                      <Icon className={`w-8 h-8 ${step.iconColor}`} />
                    </div>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {step.description}
                  </p>

                  {/* Hover Effect */}
                  <div className={`absolute inset-0 rounded-2xl bg-gradient-to-r ${step.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`}></div>
                </div>

                {/* Connector Line (except last item) */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-purple-500 to-transparent"></div>
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}





